if (!customElements.get('dynamic-atc-component')) {
  customElements.define(
    'dynamic-atc-component',
    class DynamicATCComponent extends HTMLElement {
      constructor() {
        super();
        this.variant = null;
      }

      toLocaleCurrency(str) {
        const locale = window.Shopify?.locale || 'en';
        const currency = window.Shopify?.currency?.active || 'USD';

        return str.toLocaleString(locale, {
          style: 'currency',
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      }

      connectedCallback() {
        let self = this;
        const isSticky = Boolean(self.dataset.stickyEnabled === 'true');

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleOptionValueChange.bind(this),
        );

        this.addEventListener('click', this.clickHandler.bind(self));

        // set dimensional variables so there are no guesswork to be done by the css processor leading to weird layout overflows
        if (isSticky) {
          window.addEventListener('resize', this.updateDimensions.bind(this));
          this.updateDimensions();
        }

        setTimeout(() => {
          if (isSticky) {
            this.observeIntersection(self);
            this.updateDimensions();
          }
          this.variant = this.getCurrentVariant().id;
          this.querySelector('.plan-packs input:checked+label').click();
          this.updateATCInput();
        }, 300);
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.removeEventListener('click', this.clickHandler);
      }

      updateDimensions() {
        let width = screen.width < window.innerWidth ? screen.width : window.innerWidth; // take the smaller width
        const setStickyBarWidth = (width) => {
          this.style.setProperty('--sticky-bar-width', `${width}px`);
        };
        const setPlansContainerWidth = (width) => {
          if (width < 750) {
            this.style.setProperty('--plans-container-width', `${width}px`);
          } else {
            this.style.setProperty('--plans-container-width', `500px`);
          }
        };
        const setBuyButtonContainerHeight = () => {
          this.style.setProperty(
            '--buy-button-container-height',
            `${this.querySelector('.buy-button-container').getBoundingClientRect().height - 1}px`,
          );
        };

        setStickyBarWidth(width);
        setPlansContainerWidth(width);
        setBuyButtonContainerHeight();
      }

      updatePriceLabels(variant) {
        document.querySelector('product-info .product__info-container pricing-line')?.setProduct(variant);
        document.querySelector('product-info .product__info-container pricing-line')?.setSubscriptionStatus();
        document.querySelector('product-info .product__info-container pricing-line')?.updatePrices();
        document.querySelector('product-info .product__info-container pricing-line')?.updatePercentSavings();
      }

      waitForStickyATC() {
        const selector = 'dynamic-atc-component:has(.sticky-atc)';

        return new Promise((resolve) => {
          if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
          }

          const observer = new MutationObserver((mutations) => {
            if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
            }
          });

          observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
          });
        });
      }

      updateATCInput() {
        const plan = this.querySelector('.plan-packs input:checked').id;
        const shipment = this.querySelector('.shipment-schedule input:checked').id;
        const variant = this.variant;
        const form = this.querySelector('form[action="/cart/add"]');
        const autoshipOptLabel = this.querySelector('label[for="ship-subscribe"]');

        autoshipOptLabel.querySelector('strong').innerHTML =
          `Get ${this.querySelector(`.plan-packs label[for="${plan}"]`).dataset.subSavings} off`;
        if (variant) {
          form.querySelector('input[name="id"]').setAttribute('value', variant);
        }
        if (shipment === 'ship-one-time') {
          document.querySelector('[id*="MainProduct"]').dataset.subscribed = 'false';
          this.updateSavingsLabel(this.querySelector(`.plan-packs label[for="${plan}"]`).dataset.savings);
          this.updateATCLabel(
            this.querySelector(`.plan-packs label[for="${plan}"]`).dataset.price,
            this.querySelector(`.plan-packs label[for="${plan}"]`).dataset.compareAtPrice,
          );

          if (form.querySelector('input[name="selling_plan"]')) {
            form.querySelector('input[name="selling_plan"]').remove();
          }
        }
        if (shipment == 'ship-subscribe') {
          document.querySelector('[id*="MainProduct"]').dataset.subscribed = 'true';
          this.updateSavingsLabel(this.querySelector(`.plan-packs label[for="${plan}"]`).dataset.subSavings);
          this.updateATCLabel(
            this.querySelector(`.plan-packs label[for="${plan}"]`).dataset.subPrice,
            this.querySelector(`.plan-packs label[for="${plan}"]`).dataset.compareAtPrice,
          );

          if (form.querySelector('input[name="selling_plan"]')) {
            form.querySelector('input[name="selling_plan"]').setAttribute('value', plan);
          } else {
            let sellingPlanInput = document.createElement('input');
            sellingPlanInput.setAttribute('type', 'hidden');
            sellingPlanInput.setAttribute('name', 'selling_plan');
            sellingPlanInput.setAttribute('value', plan);

            form.appendChild(sellingPlanInput);
          }
        }
        if (this.getCurrentVariant()) {
          this.updatePriceLabels(this.getCurrentVariant());
        }
      }
      updateATCLabel(price, compPrice) {
        let formattedPrice = this.toLocaleCurrency(parseInt(price) / 100);
        let formattedCompPrice = this.toLocaleCurrency(parseInt(compPrice) / 100);

        if (formattedPrice !== formattedCompPrice) {
          this.querySelector('.buy-button-container product-form button span').innerHTML =
            `Add To Cart — <s>${formattedCompPrice}</s> ${formattedPrice} `;
        } else {
          this.querySelector('.buy-button-container product-form button span').innerHTML =
            `Add To Cart — ${formattedPrice} `;
        }
      }

      updateSavingsLabel(savings) {
        if (savings !== '0%') {
          this.querySelector('.total-savings').classList.remove('hidden');
          this.querySelector('.total-savings strong').innerHTML = `you're saving ${savings}`;
        } else {
          this.querySelector('.total-savings').classList.add('hidden');
        }
      }

      getCurrentVariant() {
        return JSON.parse(document.querySelector('product-info variant-selects [data-selected-variant]').textContent);
      }

      clickHandler(event) {
        const { target } = event;

        // trigger variant option associated with selling plan
        if (target.closest('.plan-packs')) {
          if (target.closest('label')) {
            const packPlanId = target.closest('label').getAttribute('for');
            const packValue = target.closest('label').dataset.packValue;
            const variantOption = document.querySelector(
              `variant-selects [data-option-name="Pack"] [data-pack-value="${packValue}"]`,
            );

            this.querySelector('.shipment-information.subscribe').innerHTML = '';
            if (this.querySelector(`template#refill-plan-${packPlanId}`)) {
              this.querySelector('.shipment-information.subscribe').appendChild(
                this.querySelector(`template#refill-plan-${packPlanId}`).content.cloneNode(true),
              );
            } else {
              this.querySelector('.shipment-information.subscribe').appendChild(
                this.querySelector(`template#defaultSubscriptionMessage`).content.cloneNode(true),
              );
            }

            if (variantOption) {
              variantOption.click();
            }
          }
        }
        if (target.closest('.shipment-schedule')) {
          this.updateATCInput();
        }

        // toggle drawer
        if (target.closest('.plan-drawer-toggle')) {
          this.querySelector('.plans-container').classList.toggle('drawer-open');
        }
      }

      handleOptionValueChange({ data }) {
        if (data.variant) {
          this.variant = data.variant.id;
          this.updateATCInput();
        }
      }

      adjustSienna() {
        let buy_button = document.querySelector('.buy-button-container .product-form');
        let button_height = buy_button.clientHeight;

        document.body.classList.add('has-sticky-atc');
        document.body.style.setProperty('--sticky-height', `${button_height}px`);
        console.log('Setting sticky height to', `${button_height}px`);
      }

      observeIntersection(target) {
        function debounce(func, delay) {
          let timeout;
          return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), delay);
          };
        }
        const intersectionObserver = new window.IntersectionObserver(
          debounce(([entry]) => {
            if (!entry.isIntersecting) {
              target.querySelector('.outer-wrapper').classList.add('sticky-atc');
              this.updateDimensions();

              this.adjustSienna();
            } else {
              target.querySelector('.outer-wrapper').classList.remove('sticky-atc');
              document.body.classList.remove('has-sticky-atc');

              this.style.setProperty('--plans-container-height', `${this.getBoundingClientRect().height}px`);
            }
          }, 100),
          {
            root: null,
            rootMargin: '-25px 0px -50px 0px',
            threshold: 0.25,
          },
        );

        intersectionObserver.observe(target);
      }
    },
  );
}
